import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AlertProvider } from './contexts/AlertContext';
import { PrivateRoute } from './components/PrivateRoute';
import { ProjectListPage } from './pages/ProjectListPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { LoginPage } from './components/LoginPage';
import { SsoPage } from './components/SsoPage';
import { Sidebar } from './components/Sidebar';
import { BiddingPage } from './pages/BiddingPage';
import { SchedulesPage } from './pages/SchedulesPage';
import { ArchivePage } from './pages/ArchivePage';
import { DashboardPage } from './pages/DashboardPage';
import { AiPage } from './pages/AiPage';
import { CompanyDocsPage } from './pages/CompanyDocsPage';

/* 경로는 메뉴 구조를 따른다 (components/menu.tsx).
 * 2026-09-21 에 다섯 메뉴가 다 생겨 ComingSoonPage 를 지웠다. 화면을 또
 * 미뤄 두게 되면 git 에서 꺼내 온다.
 *
 * 2026-09-20 에 단계별 경로(/plans·/proposals·/bids/review)를 `/projects`
 * 하나로 합쳤다. 옛 경로는 북마크가 깨지지 않게 넘겨준다.
 * `/projects` 는 그때 「4 수행」이었고 지금은 목록 자체다. */
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AlertProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* admin 바로 이동(handbook #16) */}
          <Route path="/sso" element={<SsoPage />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Sidebar>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/bids" element={<BiddingPage />} />
                    <Route path="/projects" element={<ProjectListPage />} />
                    <Route path="/projects/:id" element={<ProjectDetailPage />} />
                    <Route path="/schedules" element={<SchedulesPage />} />
                    <Route path="/archive" element={<ArchivePage />} />
                    <Route path="/company-docs" element={<CompanyDocsPage />} />
                    <Route path="/ai" element={<AiPage />} />
                    {/* 옛 경로 — 북마크가 깨지지 않게 남긴다 */}
                    <Route path="/bids/review" element={<Navigate to="/projects" replace />} />
                    <Route path="/bids/schedules" element={<Navigate to="/schedules" replace />} />
                    <Route path="/plans/:id" element={<OldDetailRedirect />} />
                    <Route path="/proposals/:id" element={<OldDetailRedirect />} />
                    <Route path="/plans" element={<Navigate to="/projects" replace />} />
                    <Route path="/proposals" element={<Navigate to="/projects" replace />} />
                    <Route path="*" element={<Navigate to="/bids" replace />} />
                  </Routes>
                </Sidebar>
              </PrivateRoute>
            }
          />
        </Routes>
        </AlertProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

/** 옛 단계별 상세 경로를 프로젝트 상세로 넘긴다 */
const OldDetailRedirect: React.FC = () => {
  const { id } = useParams();
  return <Navigate to={`/projects/${id}`} replace />;
};

export default App;
